import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";
import { getCookie } from "../../Utils/cookieshelper";

export const ScoringProgress = ({ score }) => {
  const safety_index = 60;
  const coldprops = {
    percent: Math.round(
      // element?.stakingRisk?.safetyIndex
      //   ? element?.stakingRisk?.safetyIndex:
      // clampedSafetyIndex
      safety_index
    ), // is require
    colorSlice: "#4DC7B5",
    fontColor: "#4DC7B5",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 30,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const riskprops = {
    percent: Math.round(
      // element?.stakingRisk?.safetyIndex
      //   ? element?.stakingRisk?.safetyIndex:
      // clampedSafetyIndex
      safety_index
    ), // is require
    colorSlice: "#EFB661",
    fontColor: "#EFB661",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 30,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const holdprops = {
    percent: Math.round(
      // element?.stakingRisk?.safetyIndex
      //   ? element?.stakingRisk?.safetyIndex:
      // clampedSafetyIndex
      safety_index
    ), // is require
    colorSlice: "#F27281",
    fontColor: "#F27281",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 30,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const whiteprops = {
    percent: 0, // is require
    colorSlice: "#f0f0f3",
    fontColor: "#f0f0f3",
    fontSize: "1.625em",
    fontWeight: 900,
    size: 30,
    boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
    unit: "",
    textPosition: "0.35em",
    animationOff: false,
    inverse: false,
    round: true,
    number: false,
  };

  const renderClassNameNewAssets = (safetyIndex) => {
    if (safetyIndex >= 80) {
      return {
        className: "card cold defi", // green
        color: "#4dc7b5",
        props: coldprops,
      };
    } else if (safetyIndex >= 52 && safetyIndex <= 79) {
      return {
        className: "card hold defi", // yellow
        color: "#EFB661",
        props: riskprops,
      };
    } else if (safetyIndex <= 51) {
      return {
        className: "card risky defi", // red
        color: "#F27281",
        props: holdprops,
      };
    } else {
      return {
        className: "card empty defi",
        color: "#C4C4C4",
        props: whiteprops,
      };
    }
  };

  const renderClassNameExistingAssets = (safetyIndex) => {
    if (safetyIndex > 79) {
      return {
        className: "card cold defi", // green
        color: "#4dc7b5",
        props: coldprops,
      };
    } else if (safetyIndex >= 64 && safetyIndex <= 79) {
      return {
        className: "card hold defi", // yellow
        color: "#EFB661",
        props: riskprops,
      };
    } else if (safetyIndex <= 63) {
      return {
        className: "card risky defi", // red
        color: "#F27281",
        props: holdprops,
      };
    } else {
      return {
        className: "card empty defi",
        color: "#C4C4C4",
        props: whiteprops,
      };
    }
  };

  const savedAlgorithm = getCookie("selectedAlgorithm");
  const renderClassName =
    savedAlgorithm?.name === "Existing Assets"
      ? renderClassNameExistingAssets
      : renderClassNameNewAssets;

  const result = renderClassName(safety_index);
  return (
    <div
      className="card__risk__chart"
      style={{
        marginTop: "5px",
        width: "30px",
        height: "30px",
        display: "inline-block",
        marginLeft: "25px",
        position: "relative",
        verticalAlign: "bottom",
      }}
    >
      <CircularProgressBar {...renderClassName(score)?.props}>
        <div
          className="card__round__shadow"
          style={{
            width: "44px",
            height: "44px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            borderRadius: "50%",
            boxShadow: "inset 0 3px 6px #00000029, 0 3px 6px #00000029",
            pointerEvents: "none",
          }}
        ></div>
        <div
          className="card__risk__chart__min__wrapper"
          style={{ top: "48%", left: "47%" }}
        >
          <p
            className="card__risk__chart__number"
            style={{
              color: renderClassName(score)?.color,
              fontSize: "14px",
            }}
          >
            {Math.round(score)}
          </p>
        </div>
      </CircularProgressBar>
    </div>
  );
};
